import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, get, update, onValue } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCiwDvPW3pKUoFuVo8g3JfoIy2OyInbIYE",
  authDomain: "mis--international.firebaseapp.com",
  databaseURL: "https://mis--international-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "mis--international",
  storageBucket: "mis--international.firebasestorage.app",
  messagingSenderId: "192543315189",
  appId: "1:192543315189:web:ad898561cb2d975f74a1bc",
  measurementId: "G-HFDFVZ5HLD"
};
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const storage = getStorage(app);

// ============ SETTINGS FUNCTIONS ============

export const getSettings = async () => {
  const settingsRef = ref(db, 'settings');
  const snapshot = await get(settingsRef);
  if (snapshot.exists()) {
    return snapshot.val();
  }
  const defaultSettings = {
    schoolName: 'MIS International School',
    logo: '',
    favicon: '',
    primaryColor: '#1a3a6b',
    secondaryColor: '#f59e0b',
    headerBgColor: '#1a3a6b',
    footerBgColor: '#0f2244',
    bodyBgColor: '#ffffff',
    headerTextColor: '#ffffff',
    footerTextColor: '#ffffff',
    address: '123 Education Lane, Knowledge City, India 226001',
    phone: '+91 522 123 4567',
    email: 'info@mis-school.edu',
    googleMapEmbedUrl: '',
    facebook: '',
    twitter: '',
    instagram: '',
    youtube: '',
    copyright: '© 2026 MIS International School. All Rights Reserved.',
    navLinks: [],
    globalBannerImages: [],
    globalBannerTitle: 'Welcome to MIS International School',
    globalBannerSubtitle: 'Excellence in Education Since 1995',
    globalBannerButtonText: 'Learn More',
    globalBannerButtonLink: '/about'
  };
  await set(settingsRef, defaultSettings);
  return defaultSettings;
};

export const saveSettings = async (settings) => {
  const settingsRef = ref(db, 'settings');
  await set(settingsRef, settings);
};

export const subscribeToSettings = (callback) => {
  const settingsRef = ref(db, 'settings');
  return onValue(settingsRef, (snapshot) => {
    callback(snapshot.exists() ? snapshot.val() : null);
  });
};

// ============ CONTENT FUNCTIONS ============

export const getContent = async () => {
  const contentRef = ref(db, 'websiteContent');
  const snapshot = await get(contentRef);
  if (snapshot.exists()) {
    return snapshot.val();
  }
  const defaultContent = {
    heroTitle: 'Welcome to MIS International School',
    heroSubtitle: 'Excellence in Education Since 1995',
    heroImage: '',
    aboutText: 'We provide quality education with modern facilities and experienced faculty.',
    aboutImage: '',
    features: [],
    announcements: []
  };
  await set(contentRef, defaultContent);
  return defaultContent;
};

export const saveContent = async (content) => {
  const contentRef = ref(db, 'websiteContent');
  await set(contentRef, content);
};

export const subscribeToContent = (callback) => {
  const contentRef = ref(db, 'websiteContent');
  return onValue(contentRef, (snapshot) => {
    callback(snapshot.exists() ? snapshot.val() : null);
  });
};

// ============ PAGE FUNCTIONS ============

export const getAllPages = async () => {
  const pagesRef = ref(db, 'pages');
  const snapshot = await get(pagesRef);
  return snapshot.exists() ? snapshot.val() : {};
};

export const getPageContent = async (pageId) => {
  const pageRef = ref(db, `pages/${pageId}`);
  const snapshot = await get(pageRef);
  return snapshot.exists() ? snapshot.val() : { title: pageId, content: '' };
};

export const savePageContent = async (pageId, content) => {
  const pageRef = ref(db, `pages/${pageId}`);
  await set(pageRef, content);
};

export const subscribeToPage = (pageId, callback) => {
  const pageRef = ref(db, `pages/${pageId}`);
  return onValue(pageRef, (snapshot) => {
    callback(snapshot.exists() ? snapshot.val() : null);
  });
};

// ============ FILE UPLOAD FUNCTIONS ============

export const uploadFile = async (file, path) => {
  const fileName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g, '_')}`;
  const fileRef = storageRef(storage, `files/${path}/${fileName}`);
  await uploadBytes(fileRef, file);
  const url = await getDownloadURL(fileRef);
  return { url, name: file.name, size: file.size, type: file.type };
};

export const uploadImage = async (file, folder) => {
  const fileName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g, '_')}`;
  const imageRef = storageRef(storage, `images/${folder}/${fileName}`);
  await uploadBytes(imageRef, file);
  return await getDownloadURL(imageRef);
};

// ============ DELETE IMAGE FROM STORAGE ============
export const deleteImageFromStorage = async (imageUrl) => {
  try {
    if (!imageUrl) return false;
    // Extract the path from the Firebase Storage URL
    // URL format: https://firebasestorage.googleapis.com/v0/b/BUCKET/o/images%2Fpath%2Ffilename.jpg?alt=media&token=...
    const url = new URL(imageUrl);
    let path = url.pathname.split('/o/')[1];
    if (path) {
      path = decodeURIComponent(path.split('?')[0]);
      const imageRef = storageRef(storage, path);
      await deleteObject(imageRef);
      console.log('Image deleted successfully:', path);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error deleting image from storage:', error);
    throw error;
  }
};

// ============ DELETE FILE FROM STORAGE ============
export const deleteFileFromStorage = async (fileUrl) => {
  try {
    if (!fileUrl) return false;
    const url = new URL(fileUrl);
    let path = url.pathname.split('/o/')[1];
    if (path) {
      path = decodeURIComponent(path.split('?')[0]);
      const fileRef = storageRef(storage, path);
      await deleteObject(fileRef);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error deleting file from storage:', error);
    throw error;
  }
};

export default app;